<template>
  <div class="main">
    <van-nav-bar title="个人信息" />
    <van-form @submit="onSubmit" :submit-on-enter="false">
      <van-field input-align="right" v-model="userInfo.docname" label="姓名" placeholder="请输入姓名"
        :rules="[{ required: true, message: '请填写用户名' }]" />
      <van-field input-align="right" v-model="userInfo.docnumber" label="证件号码" placeholder="请输入证件号码"
        :rules="[{ required: true, message: '请填写证件号码' }]" />
      <van-field input-align="right" v-model="userInfo.bank" label="银行卡" placeholder="请输入银行卡"
        :rules="[{ required: true, message: '请填写银行卡' }]" />
      <van-button round block type="info" native-type="submit">点击查询</van-button>
    </van-form>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="wrapper" @click.stop>
        <van-loading color="#0094ff">查询中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {
        docname: '',
        docnumber: '',
        bank: ''
      },
      showOverlay: false
    }
  },
  mounted() {

  },
  methods: {
    onSubmit() {
      this.showOverlay = true
      setTimeout(() => {
        this.showOverlay = false
        this.$router.push('/score/show')
      }, 1000);
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
